var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEngine = function SvgEngine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6 5.5H8v-.8h4v.8h-1.6V7H13.5v2.835h2V12.115h-2V15H7.35L5 13v-1.6H3.8V13H3V9h.8v1.6H5V9l2.25-2H9.6V5.5Zm3.1 4.335v.8h2v.68h-2V14.2H7.644L5.8 12.63V9.36L7.554 7.8H12.7v2.035ZM16.2 8v6h.8V8h-.8Z",
    fill: "currentColor"
  })));
};
export default SvgEngine;